import { urls } from "../urls";
export const memberV2Service = urls.developmentUrl + ':5004/v1/'
// export const memberV2Service = "https://b74a-41-215-76-14.ngrok.io/v1/";


export const memberV2Urls = {
  postMemberV2: memberV2Service + "add/member",
  postExistingMemberV2: memberV2Service + "add/existing/member",
  editMemberV2: memberV2Service + "update/member-details",
  deleteMemberV2: memberV2Service + "delete/member",
};


